module.exports = __webpack_public_path__ + "static/media/italian_flag.d3ad8488.svg";